// strings/creator.ts (M0-T06, §7.1) — character creator
import type { StringBank } from '../schema/strings';

export default {
  title: 'Make your character', editTitle: 'Your character', nameLabel: 'Your name', nameHint: '{min}–{max} characters',
  skin: 'Skin', eyes: 'Eyes', hairStyle: 'Hair', hairColor: 'Hair colour', shirt: 'Shirt', pants: 'Trousers', shoes: 'Shoes',
  myTownColor: 'My town colour', save: 'Save', saving: 'Saving…', saved: 'Saved!', tabFace: 'Face', tabHair: 'Hair', tabClothes: 'Clothes',
} as const satisfies StringBank;
